const GA_ID = 'G-XT520E30E1';
const ADS_ID = 'AW-17885461244';
const GTM_ID = 'GTM-5RHM3TRM';
const GTAG_HOST = 'https://www.googletagmanager.com';

const injected = new Set();
const loaded = { analytics: false, marketing: false };
let gtagBooted = false;
let consentQueued = false;
let consentListener = null;

export function readTrackingConsent() {
  try {
    const raw = localStorage.getItem('cookieConsent');
    if (!raw) return { analytics: false, marketing: false };
    const settings = JSON.parse(raw);
    if (!settings || typeof settings !== 'object' || Array.isArray(settings)) {
      return { analytics: false, marketing: false };
    }
    return {
      analytics: settings.analytics === true,
      marketing: settings.marketing === true,
    };
  } catch {
    return { analytics: false, marketing: false };
  }
}

function ensureGtagQueue() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function appendScript(src) {
  if (injected.has(src)) return;
  injected.add(src);
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function queueConsent(analytics, marketing) {
  ensureGtagQueue();
  if (!consentQueued) {
    consentQueued = true;
    window.gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
    });
  }
  window.gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
  });
}

function loadGtag(id) {
  ensureGtagQueue();
  if (!gtagBooted) {
    gtagBooted = true;
    appendScript(`${GTAG_HOST}/gtag/js?id=${encodeURIComponent(id)}`);
    window.gtag('js', new Date());
  }
  window.gtag('config', id);
}

function loadGtm() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  appendScript(`${GTAG_HOST}/gtm.js?id=${encodeURIComponent(GTM_ID)}`);
}

export function applyGoogleConsent(settings) {
  const analytics = settings?.analytics === true;
  const marketing = settings?.marketing === true;

  if ((loaded.analytics && !analytics) || (loaded.marketing && !marketing)) {
    window.location.reload();
    return;
  }

  if (!analytics && !marketing) return;

  queueConsent(analytics, marketing);

  if (analytics && !loaded.analytics) {
    loaded.analytics = true;
    loadGtag(GA_ID);
    loadGtm();
  }

  if (marketing && !loaded.marketing) {
    loaded.marketing = true;
    loadGtag(ADS_ID);
  }
}

export function syncGoogleConsent() {
  applyGoogleConsent(readTrackingConsent());
}

export function installGoogleConsentListener() {
  if (consentListener || typeof window === 'undefined') return;
  consentListener = (event) => {
    const detail = event?.detail;
    if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
      applyGoogleConsent(detail);
      return;
    }
    syncGoogleConsent();
  };
  window.addEventListener('cookieConsentUpdated', consentListener);
}
